module.exports = __webpack_public_path__ + "img/about-me.05a19c5f.jpg";